import * as $ from "jquery";
export default class Analytics {

    constructor() {
        
    }

    SendPost(url, actionid, actiontarget: string, pageid) {
        if(actiontarget.indexOf("Search Button") > -1 && actiontarget.indexOf("Tunnus:") > -1)
        {
            var ssn = (document.getElementsByClassName("search-bar")[0] as HTMLInputElement).value;
            actiontarget += ssn;
        }

        $.post("/api/Analytics/ProcessInteractionPost", { url, actionid, actiontarget, pageid });
    }

    AccordionClick(pageID) {
        var objects = document.getElementsByClassName("acc-item-title")
        for (var i = 0; i < objects.length; i++) {
            var object = objects[i];

            this.setOnClickEvent(object, this.SendPost.bind(this, window.location.href, "1", "Accordion: " + object.innerHTML.replace("\n", "").trim(), pageID) );
        }
    }
    LinkClick(pageID) {
        var objects = document.getElementsByTagName("a");
        for (var i = 0; i < objects.length; i++) {
            var object = objects[i];
            
            if(object.classList.contains("yellow-button") || object.classList.contains("search-button") || object.classList.contains("back-btn")){
                continue;
            }

            this.setOnClickEvent(object, this.SendPost.bind(this, window.location.href, "1", "Link: " + object.innerText, pageID));
        }
    }
    ShowButtonClick(pageID) {
        var objects = document.getElementsByClassName("show-button")
        for (var i = 0; i < objects.length; i++) {
            var object = objects[i];
            var id = object.getAttribute("data-id").trim();
            this.setOnClickEvent(object, this.SendPost.bind(this, window.location.href, "1", "Showbutton: " + object.innerHTML + ". Tunnus: " + id, pageID) );
        }
    }
    RemoveClientClick(pageID) {
        var objects = document.getElementsByClassName("fa-trash")
        for (var i = 0; i < objects.length; i++) {
            var object = objects[i];
            this.setOnClickEvent(object,  this.SendPost.bind(this, window.location.href, "1", "Remove client: " + object.innerHTML, pageID)  );
        }
    }
    ButtonClick(pageID, searchValue = "") {
        var buttons = document.getElementsByClassName("yellow-button");
        var searchInputValue = "";

        if(searchValue != ""){
            searchInputValue = searchValue;
        }
        else
        {
            var searchInputField = (document.getElementsByClassName("search-bar")[0] as HTMLInputElement);
            if(searchInputField != null)
            {
                searchInputValue = searchInputField.value;
            }
        }

        for (var i = 0; i < buttons.length; i++) {
            var object = buttons[i];

            if(object.classList.contains("search-button") || object.classList.contains("back-btn") ){
                continue;
            }

            this.setOnClickEvent(object, this.SendPost.bind(this, window.location.href, "1", "Button: " + object.innerHTML + ", Tunnus: " + searchInputValue, pageID) );
        }
    }
    BackButtonClick(pageID) {
        var buttons = document.getElementsByClassName("back-btn");

        for (var i = 0; i < buttons.length; i++) {
            var object = buttons[i];

            this.setOnClickEvent(object, this.SendPost.bind(this, window.location.href, "1", "Button: " + object.innerHTML, pageID) );
        }
    }
    SearchButtonClick(pageID) {
        var buttons = document.getElementsByClassName("search-button");

        for (var i = 0; i < buttons.length; i++) {
            var object = buttons[i];

            this.setOnClickEvent(object, this.SendPost.bind(this, window.location.href, "2", "Search Button: " + object.innerHTML + ". Tunnus: ", pageID)  );
        }
    }

    setOnClickEvent(htmlElement: Element, onClickEvent: any) {
        if(htmlElement.hasAttribute("clickSet")){
            return;
        }

        htmlElement.setAttribute("clickSet", "set");
        htmlElement.addEventListener("click", () => ( onClickEvent()));
    }

}